import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { SubHeaderWrapper, StyledTabPane, StyledSubMenu } from './styled'

import { getUser } from '../../../selectors/user'
import { CONTENT_SUB_HEADER_FROM, createTabBarRenderer } from './renderTabBar'

const ContentSubHeader = ({ active, history, user }) => {
  const userType = user.role === 'edulastic-admin' ? 'admin' : 'author'

  useEffect(() => {
    const { state } = history.location
    // Only run this logic on programmatic navigation, not on page refresh
    // history.action === 'PUSH' or 'REPLACE' means programmatic navigation
    // history.action === 'POP' means browser navigation (refresh, back, forward)
    if (state?.from === CONTENT_SUB_HEADER_FROM && history.action !== 'POP') {
      const activeTabElement = document.querySelector(
        '.ant-tabs-tab[aria-selected="true"]'
      )
      if (activeTabElement) {
        activeTabElement.focus()
      }
    }
    // set tabindex to -1 to prevent focus on tabs bar to avoid additional focus stop
    const bar = document.querySelector('.ant-tabs-bar')
    if (bar) bar.setAttribute('tabindex', '-1')
  }, [])

  const onSubTab = (key, e) => {
    switch (key) {
      case 'Collections':
        history.push(`/${userType}/content/collections`, {
          from: CONTENT_SUB_HEADER_FROM,
        })
        return
      case 'Buckets':
        history.push(`/${userType}/content/buckets`, {
          from: CONTENT_SUB_HEADER_FROM,
        })
        return
      case 'ExternalTools':
        history.push(`/${userType}/content/tools`, {
          from: CONTENT_SUB_HEADER_FROM,
        })
        return
      default:
        return
    }
  }
  return (
    <SubHeaderWrapper>
      {active.mainMenu === 'Content' && (
        <StyledSubMenu
          mode="horizontal"
          defaultActiveKey={active.subMenu}
          onTabClick={onSubTab}
          renderTabBar={createTabBarRenderer(active.subMenu)}
        >
          <StyledTabPane tab="Collections" key="Collections" />
          <StyledTabPane tab="Buckets" key="Buckets" />
          <StyledTabPane tab="External Tools" key="ExternalTools" />
        </StyledSubMenu>
      )}
    </SubHeaderWrapper>
  )
}

export default connect(
  (state) => ({
    user: getUser(state),
  }),
  {}
)(ContentSubHeader)
